import * as v from "valibot";
import { rpcContract } from "../rpc";

export const resolveEventScopedLinksRpcContract = rpcContract({
  name: "resolve-event-scoped-links",
  paramsSchema: v.object({
    event_id: v.string(),
    action: v.picklist(["make_global", "delete"]),
  }),
  resultSchema: v.object({
    affected_count: v.number(),
    action: v.picklist(["make_global", "delete"]),
  }),
});

export type ResolveEventScopedLinksParams = v.InferOutput<(typeof resolveEventScopedLinksRpcContract)["paramsSchema"]>;
export type ResolveEventScopedLinksResult = v.InferOutput<(typeof resolveEventScopedLinksRpcContract)["resultSchema"]>;
